import React, { FC } from 'react'
import GridLayout from '../../components/GridLayout'

import ManagerDivisions from '../managerDivisions'
import ManagerTeams from '../managerTeams'

const ManagerGroups: FC = () => {
  return (
    <div className="groups">
      <GridLayout className="-two-col" scrollable offset={131}>
        <div className="divisions">
          <ManagerDivisions />
        </div>
        <div className="teams">
          <ManagerTeams />
        </div>
      </GridLayout>
    </div>
  )
}

export default ManagerGroups
